export const encodeNftId = (accountId, contract, tokenId, currencyId) => {
    return `${accountId}+${contract}+${tokenId}+${currencyId}`;
};
export const decodeNftId = (id) => {
    const [accountId, contract, tokenId, currencyId] = id.split("+");
    return {
        accountId,
        contract,
        tokenId,
        currencyId,
    };
};
//# sourceMappingURL=nftId.js.map